import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Warranty from "@/pages/Warranty";
import SpecialRequests from "@/pages/SpecialRequests";
import Contact from "@/pages/Contact";
import PaymentResult from "@/pages/PaymentResult";
import DealerForm from "@/pages/DealerForm";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (admin === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D0A] text-[#8CE63C] font-mono text-sm">
        Authenticating…
      </div>
    );
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/special-requests" element={<SpecialRequests />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment/success" element={<PaymentResult status="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
            <Route path="/dealers" element={<DealerForm />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
